import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const Prodforyou = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const scrollRef = useRef(null);
  const headRef = useRef(null);          // 🔥 added
  const cardRefs = useRef([]);           // 🔥 added

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const catRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        if (catRes.data.status === true || catRes.data.status === "true") {
          setCategories(catRes.data.row);
        }

        const prodRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );
        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) =>
              item.product_status === "Products for you" &&
              item.admin_approval === "approval" &&
              item.paid_approval === "yes"
          );
          setProducts(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }
      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // 🔥 Intersection Observer — same as CrazyDeals
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headRef.current) observer.observe(headRef.current);
    cardRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [products]); // 🔥 re-run after products load

  const getCategoryName = (catId) => {
    const found = categories.find((c) => c.category_id === catId);
    return found ? found.category_name : "Unknown Category";
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <div className="container my-4 bg-white">

      {/* 🔥 ref + tp-head class added */}
      <div
        className="d-flex justify-content-between align-items-center tp-head"
        ref={headRef}
      >
        <h3 className="fw-bold p-1">Products for you</h3>

        <Link
          to="/products"
          state={{ categoryId: 1 }}
          className="text-decoration-none"
          style={{ color:  "rgb(252, 146, 204)", }}
        >
          View All <i className="bi bi-chevron-right"></i>
        </Link>
      </div>

      <div className="position-relative">

        <button onClick={scrollLeft} className="scroll-btn left">‹</button>

        <div
          ref={scrollRef}
          className="d-flex overflow-auto gap-3 px-2 top-picks-scroll"
        >
          {products.map((product, index) => (   // 🔥 index added
            <div
              key={product.product_id}
              ref={(el) => (cardRefs.current[index] = el)}  // 🔥 added
              className="col-lg-2 col-md-3 col-sm-6 col-6 mb-4 d-flex flex-shrink-0 tp-card"  // 🔥 tp-card added
              style={{ width: "230px", "--delay": `${index * 70}ms` }}  // 🔥 --delay added
            >
              <div className="card flex-fill h-100 shadow-sm border rounded-3">
                <img
                  src={`https://cyberathon.com/multivendor/${product.multi_image?.[0]}`}
                  className="card-img-top p-3"
                  alt={product.product_name}
                />

                <div className="card-body">
                  <h6 className="fw-bold mb-1">
                    {product.product_name?.split(" ").slice(0, 2).join(" ")}
                  </h6>

                  <div className="price-new d-flex align-items-center gap-2 flex-wrap">
                    <h6 className="fw-bold mb-0">₹{product.current_price}</h6>

                    <small className="price-old text-muted text-decoration-line-through">
                      ₹{product.old_price}
                    </small>

                    {product.discount && (
                      <small className="text-danger fw-semibold">
                        ({product.discount}% OFF)
                      </small>
                    )}
                  </div>

                  <div className="mt-2 text-center">
                    <Link to={`/model/${product.product_id}`}>
                      <button type="submit" className="Addto-cart">
                        Add to bag
                      </button>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>

        <button onClick={scrollRight} className="scroll-btn right">›</button>

      </div>
    </div>
  );
};